import HeroBannerAndLogin from "../../components/public/userLogin/HeroBannerAndLogin";
import LeadBookFeatures from "../../components/public/userLogin/LeadBookFeatures";
import PropertyBanner from "../../components/public/userLogin/PropertyBanner";
import HowItWorks from "../../components/public/userLogin/HowItWorks";
import LoginTestimonials from "../../components/public/userLogin/LoginTestimonials";
import { useAuth } from "../../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import Loader from "../../components/Loader";
// import FAQSection from "../../components/public/userLogin/FAQSection";

const Login = () => {
  const { user, hydrated } = useAuth();
  const location = useLocation();

  if (!hydrated) return <Loader />;

  if (user) {
    const from = location.state?.from?.pathname || "/";
    return <Navigate to={from} replace />;
  }

  return (
    <div className="overflow-hidden">
      <HeroBannerAndLogin />
      <LeadBookFeatures />
      <PropertyBanner />
      <HowItWorks />
      <LoginTestimonials />

      {/* <div className="px-4 sm:px-6 lg:px-10">
        <FAQSection />
      </div> */}
    </div>
  );
};

export default Login;
